import PropTypes from 'prop-types';
import { useCulture } from 'context/CultureContext';

const CultureShow = ({ children, cultures, pageCulture = null }) => {
    if (pageCulture === null) {
        const { culture } = useCulture();
        pageCulture = culture;
    }

    if (cultures.includes(pageCulture)) {
        return (
            children
        );
    } else {
        return null;
    }
};

CultureShow.propTypes = {
    children: PropTypes.element,
    cultures: PropTypes.arrayOf(PropTypes.string)
};

export default CultureShow;
